import { mobileModule } from '@/store/mobile/module'
import { clearQueryParams, type PPQueryParams } from '@/utils'
import { subscriptionModule } from '@/store/subscription/module'

const buildMobileStateFromQueryParams = (queryParams: PPQueryParams) => {
    const { platform, productIndex, ulPath } = queryParams
    if (!ulPath) {
        return
    }

    mobileModule.state.mobileAppPath = ulPath
    mobileModule.state.productIndex = productIndex && !Number.isNaN(Number(productIndex))
        ? Number(productIndex)
        : null
    mobileModule.state.platform = platform === 'Android'
        ? 'Android'
        : platform === 'iOS'
            ? 'iOS'
            : 'Web'
    mobileModule.state.hasArrivedFromMobile = true

    clearQueryParams()
}

const triggerReturnToMobileModal = () => {
    setTimeout(() => {
        mobileModule.state.showReturnToMobileModal = true
    }, 500)
}

const closeReturnToMobileModal = () => {
    mobileModule.state.showReturnToMobileModal = false
    mobileModule.state.mobileAppPath = null
    mobileModule.state.platform = null
    mobileModule.state.productIndex = null
    mobileModule.state.hasArrivedFromMobile = false
}

const returnToMobileApp = () => {
    const url = getUniversalLinkToApp()
    if (url) {
        window.open(encodeURI(url))
    }

    // close our modal and clear the state
    closeReturnToMobileModal()
}


// build full URL for Universal Link using appPath & subscription result
const getUniversalLinkToApp = (): string => {
    const appPath = mobileModule.state.mobileAppPath
    const didSubscribe = !!subscriptionModule.getters.getSubscriptionForExamId()
    // right now we know it's always an 'Upgrade' context, but if used in other contexts we need to make this flexible
    const priorScreen = 'Upgrade'
    // do not specify a particular screen eg study, use 'openApp' path to return to prior location
    return `https://pocketprep.com/apps/${appPath}/openApp?priorScreen=${priorScreen}&didSubscribe=${didSubscribe}`
}

export default {
    buildMobileStateFromQueryParams,
    triggerReturnToMobileModal,
    returnToMobileApp,
    closeReturnToMobileModal,
    getUniversalLinkToApp,
}